module.exports = __webpack_public_path__ + "img/1696399616844-kue untir bungkus j2.jpg.9b3501ea.webp";